import { useUpdateAccentraConnection } from '@/api/property-keyless/accentra/update-accentra-connection'

import { AccentraConnectionFormValues } from './accentra.schema'

export const useAccentraSubmit = (buildingId: number) => {
  const { mutateAsync, isPending } = useUpdateAccentraConnection()

  const submit = (values: AccentraConnectionFormValues) => mutateAsync({ buildingId, ...values })

  return { isPending, submit }
}
